import { FC, useEffect } from 'react';
import { graphql, useFragment, PreloadedQuery } from 'react-relay';

import CheckoutTotalsDutiesMessage from './CheckoutTotalsDutiesMessage';
import { isDapDdpCheckoutVariant, trackDapDdpCheckoutABTest } from './dapDdpCheckoutVariantHelpers';
import {
    PreloadedCustomsMessagingRenderer,
    QueryType,
} from 'dibs-customs-messaging/exports/PreloadedCustomsMessaging';

import { CheckoutDutiesMessage_viewer$key } from './__generated__/CheckoutDutiesMessage_viewer.graphql';
import { CheckoutDutiesMessage_transaction$key } from './__generated__/CheckoutDutiesMessage_transaction.graphql';

import styles from './CheckoutDutiesMessage.scss';

type Props = {
    viewer: CheckoutDutiesMessage_viewer$key | null;
    isComputing: boolean;
    transaction: CheckoutDutiesMessage_transaction$key | null;
    currency: string;
    isMobile?: boolean;
    queryReference?: PreloadedQuery<QueryType, Record<string, unknown>> | null;
};

export const CheckoutDutiesMessage: FC<Props> = props => {
    const {
        viewer: viewerRef,
        isComputing,
        transaction: transactionRef,
        currency,
        queryReference,
    } = props;

    const viewer = useFragment(
        graphql`
            fragment CheckoutDutiesMessage_viewer on Viewer {
                newDutiesMsgAndTaxEnabled: featureFlag(feature: "newDutiesMessageAndTax")
            }
        `,
        viewerRef
    );

    const transaction = useFragment(
        graphql`
            fragment CheckoutDutiesMessage_transaction on Transaction {
                isCrossBorderTransaction
                ...CheckoutTotalsDutiesMessage_transaction
            }
        `,
        transactionRef
    );
    const { isCrossBorderTransaction } = transaction || {};

    useEffect(() => {
        if (isCrossBorderTransaction) {
            trackDapDdpCheckoutABTest();
        }
    }, [isCrossBorderTransaction]);

    const newDutiesMsgAndTaxEnabled = viewer?.newDutiesMsgAndTaxEnabled;

    const nonDDPCustomsMessage = queryReference ? (
        <PreloadedCustomsMessagingRenderer
            queryReference={queryReference}
            currency={currency}
            wrapperClass={styles.customsMessagingWrapper}
            messageClass={styles.customsMessagingMessage}
        />
    ) : null;
    const currentCustomsMessage =
        newDutiesMsgAndTaxEnabled && isDapDdpCheckoutVariant ? (
            <CheckoutTotalsDutiesMessage isComputing={isComputing} transaction={transaction} />
        ) : (
            nonDDPCustomsMessage
        );

    return <> {currentCustomsMessage}</>;
};
